import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Element } from 'react-scroll';
import { pure } from 'recompose';
import parse from 'url-parse';
import v4 from 'uuid';
import { HlsPlayer } from '@/components/ui/Video/HlsPlayer';
import { propBool, propFunc, propId, propStr, PropTypesAuthToken, } from '@/helpers/custom-prop-types';
import { getText, getParentNodeName, getChildrenElements, getParseJson, } from '@/helpers/html_parser';
import TargetBlankIcon from '../../Icon/Svg/TargetBlankIcon';
import UlizaScriptComponent from '../../Ui/Script/UlizaScriptComponent';
import Hover from '../../Ui/System/Hover';
import ColumnContentButton from './HtmlParts/ColumnContentButton';
import ColumnContentColumn from './HtmlParts/ColumnContentColumn';
import ColumnContentDocument from './HtmlParts/ColumnContentDocument';
import ColumnContentRegistrationButton from './HtmlParts/ColumnContentRegistrationButton';
const ColumnComponentHtmlParser = pure((props) => {
    const { auth, content, id, isGuest, onClickButton, title } = props;
    return useMemo(() => {
        let tocIndex = 0;
        const getTocName = () => {
            const text = `toc_text_${tocIndex}`;
            tocIndex += 1;
            return text;
        };
        const transform = (node) => {
            var _a;
            let setKey = null;
            const key = () => {
                if (!setKey) {
                    setKey = v4();
                }
                return setKey;
            };
            if (node.children &&
                node.children.length > 0 &&
                node.children[0].type === 'text') {
                // textの差し替え
                const text = getText(node);
                const json = getParseJson(text);
                if (json) {
                    // 会員登録ボタン
                    if (json.type === 'member_registration') {
                        return (_jsx(ColumnContentRegistrationButton, { isGuest: isGuest }, key()));
                    }
                    // 通常ボタン
                    if (json.type === 'button' && json.link && json.text) {
                        return (_jsx(ColumnContentButton, { onClick: onClickButton, text: json.text, title: title, to: json.link }, key()));
                    }
                    // 別コラムへのリンク
                    if (json.type === 'column' && json.id) {
                        return _jsx(ColumnContentColumn, { idList: json.id }, key());
                    }
                    // 資料へのリンク
                    if (json.type === 'document' && json.id) {
                        return _jsx(ColumnContentDocument, { idList: json.id }, key());
                    }
                    // HLS動画の表示
                    if (json.type === 'hls' && json.src) {
                        return _jsx(HlsPlayer, { src: json.src }, key());
                    }
                    // ULIZAスクリプトの読み込み TODO: DB移行後に削除する
                    if (json.type === 'uliza' && json.script) {
                        return (_jsx(UlizaScriptComponent, { auth: auth, id: id, script: json.script }, key()));
                    }
                }
            }
            if (node.type === 'tag') {
                // getParentNodeName(node) !== 'figure'
                const isNodeLink = node.name === 'a' &&
                    node.attribs.href &&
                    node.attribs.href.indexOf('http') === 0;
                const parentNodeName = getParentNodeName(node);
                if (isNodeLink) {
                    const childElement = getChildrenElements(node, transform);
                    const parseData = parse(node.attribs.href);
                    const isOtherDomain = parseData.host !== window.location.host;
                    if (parentNodeName === 'figure') {
                        if (isOtherDomain) {
                            _.set(node, 'attribs.target', '_blank');
                            _.set(node, 'attribs.rel', 'noopener noreferrer');
                        }
                    }
                    else {
                        if (isOtherDomain) {
                            return (_jsx(Hover, { children: _jsxs("a", Object.assign({ href: node.attribs.href, rel: 'noopener noreferrer', target: '_blank' }, { children: [childElement, _jsx(TargetBlankIcon, {})] })) }, key()));
                        }
                        return (_jsx(Hover, { children: _jsx("a", Object.assign({ href: node.attribs.href, rel: 'noopener noreferrer', target: '_blank' }, { children: childElement })) }, key()));
                    }
                }
                if (node.name === 'h2') {
                    const text = getText(node);
                    return (_jsx(Element, Object.assign({ name: getTocName() }, { children: _jsx("h2", { children: text }) }), key()));
                }
                if (node.name === 'h3') {
                    const text = getText(node);
                    return (_jsx(Element, Object.assign({ name: getTocName() }, { children: _jsx("h3", { children: text }) }), key()));
                }
                if (node.name === 'strong') {
                    const childElement = getChildrenElements(node, transform);
                    return _jsx("b", { children: childElement }, key());
                }
                if (node.name === 'figure' && node.attribs.class === 'media') {
                    // 子要素のoembedのurl属性を取得
                    const oembedUrl = node.children[0].attribs.url || '';
                    const vimeoId = (_a = oembedUrl.match(/vimeo.com\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1];
                    if (!vimeoId) {
                        return null;
                    }
                    return (_jsx("iframe", { allow: 'fullscreen; picture-in-picture; clipboard-write; encrypted-media', className: 'aspect-video w-full', src: `https://player.vimeo.com/video/${vimeoId}`, title: '動画コンテンツ' }, key()));
                }
            }
            return undefined;
        };
        return ReactHtmlParser(content, {
            transform,
        });
    }, [auth, id, isGuest, onClickButton, title, content]);
});
ColumnComponentHtmlParser.propTypes = {
    auth: PropTypesAuthToken.isRequired,
    content: propStr().isRequired,
    id: propId(),
    isGuest: propBool().isRequired,
    onClickButton: propFunc().isRequired,
    title: propStr().isRequired,
};
ColumnComponentHtmlParser.defaultProps = {
    id: '',
};
export default ColumnComponentHtmlParser;
